'use client';

import { useEffect, useState } from 'react';

type Connection = EventTarget & {
  saveData?: boolean;
  effectiveType?: string;
};

// SSR에서는 포스터를 표시하고, 마운트 후 사용자 설정과 회선 상태를 반영한다.
export function useLiteMode() {
  const [isLiteMode, setIsLiteMode] = useState(true);

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = (navigator as Navigator & { connection?: Connection })
      .connection;
    const sync = () => {
      setIsLiteMode(
        media.matches ||
          !!connection?.saveData ||
          ['slow-2g', '2g', '3g'].includes(connection?.effectiveType ?? ''),
      );
    };
    sync();
    media.addEventListener('change', sync);
    connection?.addEventListener?.('change', sync);
    return () => {
      media.removeEventListener('change', sync);
      connection?.removeEventListener?.('change', sync);
    };
  }, []);

  return isLiteMode;
}
